import type { PageCard } from '@/play/pageTypes'
import { CursiveCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'cursive',
  number: 8,
  title: 'Cursive',
  question: 'What does writing with 3D ink look like in a dense but shallow medium, like cursive on paper?',
  status: 'open',
  accent: '#f6f0e2',
  CardArt: CursiveCardArt,
}
